import { createContext, useContext } from "react";

// Customer-profile buttons are used from cards, tables, chat, and task
// drawers. They publish an intent here; a single application-level owner
// decides how the profile drawer is mounted. Keeping the context separate
// from that owner is deliberate: consumers must not import the drawer back
// into the task-detail component tree.
export const CustomerProfileLauncherContext = createContext(null);

export function useCustomerProfileLauncher() {
  return useContext(CustomerProfileLauncherContext);
}
